var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiblioteca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.76,
    height: 75.638,
    viewBox: "0 0 72.76 75.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "biblioteca",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M68.131,21.632V12.216A1.119,1.119,0,0,0,67.012,11.1H60.931V1.119A1.119,1.119,0,0,0,59.812,0H15.059A1.119,1.119,0,0,0,13.94,1.119V11.1H7.859A1.119,1.119,0,0,0,6.74,12.216V29.879H5.752A5.257,5.257,0,0,0,.5,35.13V70.087a5.257,5.257,0,0,0,5.251,5.252H67.709a5.257,5.257,0,0,0,5.251-5.251V26.865a5.257,5.257,0,0,0-4.829-5.233ZM16.178,2.238H58.694V21.614H53.73v-9.4A1.119,1.119,0,0,0,52.611,11.1H16.178ZM2.738,70.087V35.13a3.017,3.017,0,0,1,3.014-3.014h4.38a1.119,1.119,0,0,0,0-2.238H8.978V13.334H51.492v8.28H40.147A5.257,5.257,0,0,0,34.9,26.865a3.017,3.017,0,0,1-3.014,3.014H14.608a1.119,1.119,0,0,0,0,2.238H31.882a5.258,5.258,0,0,0,5.252-5.252,3.017,3.017,0,0,1,3.014-3.014h18.7a3.017,3.017,0,0,1,3.014,3.014V70.087A3.018,3.018,0,0,1,58.855,73.1H5.752a3.017,3.017,0,0,1-3.014-3.014Zm67.984,0A3.017,3.017,0,0,1,67.709,73.1h-4.56a5.22,5.22,0,0,0,.935-2.578h2.928A1.119,1.119,0,0,0,68.131,69.4V39.739a1.119,1.119,0,0,0-2.238,0V68.284H64.1V26.865a5.259,5.259,0,0,0-3.172-4.821v-8.71h4.962v21.93a1.119,1.119,0,0,0,2.238,0V23.885a3.016,3.016,0,0,1,2.591,2.98Zm0,0",
    transform: "translate(-0.5 0)",
    fill: "#7d0000",
    stroke: "#7d0000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M91.708,117.187h26.852a1.119,1.119,0,0,0,0-2.238H91.708a1.119,1.119,0,0,0,0,2.238Zm0,0",
    transform: "translate(-77.334 -98.035)",
    fill: "#7d0000",
    stroke: "#7d0000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M91.708,155.207h15.361a1.119,1.119,0,0,0,0-2.238H91.708a1.119,1.119,0,0,0,0,2.238Zm0,0",
    transform: "translate(-77.334 -130.46)",
    fill: "#7d0000",
    stroke: "#7d0000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M247.281,244.211H224.009a1.119,1.119,0,0,0-1.119,1.119v8.279a1.119,1.119,0,0,0,1.119,1.119h23.272a1.119,1.119,0,0,0,1.119-1.119V245.33A1.119,1.119,0,0,0,247.281,244.211Zm-1.119,8.279H225.128v-6.042h21.034Zm0,0",
    transform: "translate(-190.167 -208.277)",
    fill: "#7d0000",
    stroke: "#7d0000",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiblioteca);
export default __webpack_public_path__ + "static/media/biblioteca.052fa3b34ef6c866fe1c8e5ad7cb2aee.svg";
export { ForwardRef as ReactComponent };